export default __webpack_public_path__ + "static/media/ic_round-push-pin.d4f087c5.svg";